import Vue from "vue";
import VueRouter from "vue-router";
import cookie from "vue-cookie";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("../views/app/index.vue"),
    redirect: `/home`,
    children: [
      {
        path: "home",
        component: () => import("../views/etc/Main.vue"),
      },
      {
        path: "school",
        component: () => import("../views/school/SchoolList.vue"),
      },
      {
        path: "student",
        component: () => import("../views/student/StudentList.vue"),
      },
      {
        path: "mentor",
        component: () => import("../views/mentor/MentorList.vue"),
      },
      {
        path: "platoon",
        component: () => import("../views/platoon/PlatoonList.vue"),
      },
      {
        path: "school/:slug",
        component: () => import("../views/school/SchoolDetail.vue"),
      },
      {
        path: "school-edit/:slug",
        component: () => import("../views/school/SchoolEdit.vue"),
      },
      {
        path: "school-add",
        component: () => import("../views/school/SchoolAdd.vue"),
      },
      {
        path: "user/:slug",
        component: () => import("../views/user/UserLayout.vue"),
      },
      {
        path: "user-add",
        component: () => import("../views/user/UserAdd.vue"),
      },
      {
        path: "platoon/:slug",
        component: () => import("../views/platoon/PlatoonDetail.vue"),
      },
      {
        path: "teams",
        component: () => import("../views/team/TeamList.vue"),
      },
      {
        path: "team/:slug",
        component: () => import("../views/team/TeamDetail.vue"),
      },
      {
        path: "profile",
        component: () => import("../views/user/Profile.vue"),
      },
      {
        path: "my-users",
        component: () => import("../views/user/MyPersonnel.vue"),
      },
      {
        path: "find-user",
        component: () => import("../views/user/FindUser.vue"),
      },
      {
        path: "about-us",
        component: () => import("../views/etc/AboutUs.vue"),
      },
      {
        path: "manage",
        component: () => import("../views/etc/Manage.vue"),
      },
      {
        path: "election",
        component: () => import("../views/election/Election.vue"),
      },
    ],
  },
  {
    path: "/graduate",
    component: () => import("../views/graduate/GraduateLayout.vue"),
  },
  {
    path: "/error",
    component: () => import("../views/etc/Error.vue"),
  },
  {
    path: "/login",
    component: () => import("../views/user/Login.vue"),
  },
  {
    path: "/sso",
    component: { render: (h) => h("div", { style: { display: "none" } }) },
    beforeEnter(to) {
      const token = Array.isArray(to.query.tkn) ? to.query.tkn[0] : to.query.tkn;

      if (token) {
        cookie.set("userToken", token);
        localStorage.setItem("aghighToken", token);
      }

      window.location.replace("/");
    },
  },
  {
    path: "/forgot-password",
    component: () => import("../views/user/ForgotPassword.vue"),
  },
  {
    path: "/card/:ids",
    component: () => import("../views/student/CardList.vue"),
  },
  {
    path: "/credential/:slug",
    component: () => import("../views/etc/Credential.vue"),
  },
  {
    path: "*",
    component: () =>
      import(/* webpackChunkName: "error" */ "../views/etc/Error.vue"),
  },
];

const router = new VueRouter({
  linkActiveClass: "active",
  routes,
  mode: "history",
});
export default router;
